import { Accordion, Anchor, Box, Card, Heading, Paragraph, Text } from '@zillow/constellation-10';

import StringConstants from '@common/constants/StringConstants';
import type { FaqModel } from '@common/types';

const supportEmail = StringConstants.LINKS.SUPPORT_EMAIL.zillow;
const faqLink = `${StringConstants.LINKS.FAQ_PAGE.zrm}?utm_campaign=landlord_payments_faq`;

type HeadingLevel = 2 | 3 | 4 | 5 | 6;

interface IFaqComponentProps {
  faqs?: Array<FaqModel>;
  headingLevel?: HeadingLevel;
  title?: string;
  showContactSection?: boolean;
  withBorder?: boolean;
  onFAQClick?: () => any;
  actionButton?: JSX.Element;
}

const FaqComponent = ({
  faqs,
  headingLevel = 3,
  title = 'Frequently asked questions',
  showContactSection = true,
  withBorder = true,
  onFAQClick,
  actionButton,
}: IFaqComponentProps) => {
  const renderFaqRow = ({ question, answer }, i) => {
    return (
      <Accordion.Item value={`accordion-${i}`} key={`accordion-${i}`}>
        <Accordion.Header>
          <Text textStyle="body-bold">{question}</Text>
        </Accordion.Header>
        <Accordion.Panel>
          <Paragraph>{answer}</Paragraph>
        </Accordion.Panel>
      </Accordion.Item>
    );
  };

  const renderBody = () => (
    <>
      {title && (
        <Heading level={headingLevel} css={{ textStyle: 'body-bold', marginBottom: 'default' }}>
          {title}
        </Heading>
      )}
      {faqs && (
        <Accordion.Root
          type="single"
          onExpandedChange={(expanded) => {
            if (expanded.length && onFAQClick) {
              onFAQClick();
            }
          }}
        >
          {faqs.map(({ question, answer }, i) =>
            renderFaqRow(
              {
                question,
                answer,
              },
              i,
            ),
          )}
        </Accordion.Root>
      )}
      {showContactSection && (
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'loose',
            marginTop: 'default',
          }}
        >
          <Text textStyle="body-sm">
            Visit our{' '}
            <Anchor href={faqLink} target="_blank">
              FAQ page
            </Anchor>{' '}
            for other common payments questions. Still have questions?{' '}
            <Anchor href={`mailto:${supportEmail}`}>Email us</Anchor>
          </Text>
        </Box>
      )}
      {actionButton && <Box css={{ marginTop: 'loose' }}>{actionButton}</Box>}
    </>
  );
  return withBorder ? (
    <Card
      elevated={false}
      css={{
        padding: 'loose',
        height: 'fit-content',
      }}
    >
      {renderBody()}
    </Card>
  ) : (
    renderBody()
  );
};

export default FaqComponent;
